import type {AfriexCurrencyCode} from '@/types';

export const mapOptionsToList = (options: AfriexCurrencyCode[]) =>
  options.map((currency: AfriexCurrencyCode) => ({
    value: currency,
    key: currency,
  }));
